export default __webpack_public_path__ + "static/media/patient-info-consent-form.62823466.jpeg";